/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-05-24 17:34:58
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-06 13:12:56
 */
import { FRAMEDEPTH, FRAME_HEIGHT, HIGHTLOW_SINKCABINET_HEIGHT, SKIRTINGBOARDCONFIG, TOPPANELCONFIG, } from '../../utils/kitchenConfig';
import { getDividingPosition } from '../../utils/templatejsonUtils';
// 首先把需要用到的常量先定义一下
// 台面的position的Y  高低
function getTopPanelPositionY(isHigh) {
    const topPanelPositionY = {
        highY: FRAME_HEIGHT.HIGH + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        lowY: FRAME_HEIGHT.LOW + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        midY: FRAME_HEIGHT.LOW + SKIRTINGBOARDCONFIG.HEIGHT
            + TOPPANELCONFIG.HEIGHT + (HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT) / 2,
    };
    if (isHigh === 'mid') {
        return topPanelPositionY.midY;
    }
    return topPanelPositionY[isHigh ? 'highY' : 'lowY'];
}
// L型高低柜的水槽和灶台不能在同一边   断点必在转角柜的边上
/**
 * lengthX的台面信息
 * @param renderLThis
 */
export function getLengthXTopPanelInfo(renderLThis, lengthXLength) {
    var _a;
    if (renderLThis.templateJson.bottom.highAndLow) {
        const { l1Frame: { frameInfo, isAfterDirection, }, } = getDividingPosition(renderLThis.templateJson);
        if (frameInfo) {
            const highCabinetId = (_a = frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
            const highCabinetMesh = renderLThis.scene.getMeshByName(highCabinetId);
            // 判断高台面在方向   first->extra->last     l1原点->l1远点     第一个柜子为转角柜  需要判断转角柜的柜型及方向  88转角柜及128转角柜分别处理
            // 拿到柜子的边界值
            const highCabinetEdge = highCabinetMesh.getHierarchyBoundingVectors();
            // lengthX 只需要判断X的位置就可以了 在后面是max.x   在前面就是min.x
            const topPanelDividingPosition = isAfterDirection ? highCabinetEdge.max.x : highCabinetEdge.min.x;
            // 起始点的台面
            const positionFirst = {
                x: topPanelDividingPosition / 2 + (!isAfterDirection ? (-TOPPANELCONFIG.HEIGHT / 2) : 0),
                y: getTopPanelPositionY(!isAfterDirection),
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            };
            const sizeFirst = {
                width: Math.abs(topPanelDividingPosition) + (!isAfterDirection ? TOPPANELCONFIG.HEIGHT : 0),
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            // 竖着的台面
            const positionExtra = {
                x: topPanelDividingPosition + (!isAfterDirection ? (-TOPPANELCONFIG.HEIGHT / 2) : TOPPANELCONFIG.HEIGHT / 2),
                y: getTopPanelPositionY('mid'),
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            };
            const sizeExtra = {
                width: TOPPANELCONFIG.HEIGHT,
                height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            // 远点的台面
            const positionLast = {
                x: (topPanelDividingPosition - lengthXLength.length) / 2
                    + (isAfterDirection ? (TOPPANELCONFIG.HEIGHT / 2) : 0),
                y: getTopPanelPositionY(isAfterDirection),
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            };
            const sizeLast = {
                width: Math.abs(topPanelDividingPosition + lengthXLength.length)
                    + (isAfterDirection ? TOPPANELCONFIG.HEIGHT : 0),
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            return [
                {
                    position: positionFirst, size: sizeFirst,
                }, {
                    position: positionExtra, size: sizeExtra,
                }, {
                    position: positionLast, size: sizeLast,
                },
            ];
        }
        // 是高低柜的全高或者全矮的一边   高度跟第一个柜子一样
        return [{
                position: {
                    x: lengthXLength.centerPoint,
                    y: renderLThis.templateJson.bottom.length1.frames[0].componentBasic.height * 0.001
                        + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                    z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
                },
                size: {
                    width: lengthXLength.length,
                    height: TOPPANELCONFIG.HEIGHT,
                    depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                },
            }];
    }
    return [{
            position: {
                x: lengthXLength.centerPoint,
                y: renderLThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            },
            size: {
                width: lengthXLength.length,
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            },
        }];
}
export function getLengthZTopPanelInfo(renderLThis, lengthZLength) {
    var _a;
    if (renderLThis.templateJson.bottom.highAndLow) {
        const { l2Frame: { frameInfo, isAfterDirection, }, } = getDividingPosition(renderLThis.templateJson);
        if (frameInfo) {
            const highCabinetId = (_a = frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
            const highCabinetMesh = renderLThis.scene.getMeshByName(highCabinetId);
            // 判断高台面在方向   first->extra->last     l2转角柜点->l2远点     第一个柜子为转角柜  需要判断转角柜的柜型及方向  88转角柜及128转角柜分别处理
            // 拿到柜子的边界值
            const highCabinetEdge = highCabinetMesh.getHierarchyBoundingVectors();
            const topPanelDividingPosition = isAfterDirection ? highCabinetEdge.min.z : highCabinetEdge.max.z;
            // 第一个台面的起始点的z坐标为 FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH
            const positionFirst = {
                x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
                y: getTopPanelPositionY(!isAfterDirection),
                z: (topPanelDividingPosition + FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH) / 2
                    + (!isAfterDirection ? TOPPANELCONFIG.HEIGHT / 2 : 0),
            };
            const sizeFirst = {
                width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                height: TOPPANELCONFIG.HEIGHT,
                depth: Math.abs(topPanelDividingPosition - FRAMEDEPTH.BOTTOM - TOPPANELCONFIG.DEPTH)
                    + (!isAfterDirection ? TOPPANELCONFIG.HEIGHT : 0),
            };
            const positionExtra = {
                x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
                y: getTopPanelPositionY('mid'),
                z: topPanelDividingPosition + (!isAfterDirection ? TOPPANELCONFIG.HEIGHT / 2 : (-TOPPANELCONFIG.HEIGHT / 2)),
            };
            const sizeExtra = {
                width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
                depth: TOPPANELCONFIG.HEIGHT,
            };
            const positionLast = {
                x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
                y: getTopPanelPositionY(isAfterDirection),
                z: (topPanelDividingPosition + lengthZLength.length) / 2
                    - (isAfterDirection ? (TOPPANELCONFIG.HEIGHT / 2) : 0),
            };
            const sizeLast = {
                width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                height: TOPPANELCONFIG.HEIGHT,
                depth: Math.abs(lengthZLength.length - topPanelDividingPosition)
                    + (isAfterDirection ? TOPPANELCONFIG.HEIGHT : 0),
            };
            return [
                {
                    position: positionFirst, size: sizeFirst,
                }, {
                    position: positionExtra, size: sizeExtra,
                }, {
                    position: positionLast, size: sizeLast,
                },
            ];
        }
        return [{
                position: {
                    x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
                    y: renderLThis.templateJson.bottom.length1.frames[0].componentBasic.height * 0.001
                        + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                    z: lengthZLength.centerPoint + TOPPANELCONFIG.DEPTH / 2 + FRAMEDEPTH.BOTTOM / 2,
                },
                size: {
                    width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                    height: TOPPANELCONFIG.HEIGHT,
                    depth: lengthZLength.length - TOPPANELCONFIG.DEPTH - FRAMEDEPTH.BOTTOM,
                },
            }];
    }
    return [{
            position: {
                x: -FRAMEDEPTH.BOTTOM / 2 - TOPPANELCONFIG.DEPTH / 2,
                y: renderLThis.templateJson.bottom.length1.frames[0].componentBasic.height * 0.001
                    + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: lengthZLength.centerPoint + TOPPANELCONFIG.DEPTH / 2 + FRAMEDEPTH.BOTTOM / 2,
            },
            size: {
                width: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                height: TOPPANELCONFIG.HEIGHT,
                depth: lengthZLength.length - TOPPANELCONFIG.DEPTH - FRAMEDEPTH.BOTTOM,
            },
        }];
}
